import {  useEffect } from 'react';

// https://github.com/streamich/react-use/blob/master/docs/useMount.md
const useMount = (effect) => {
  useEffect(effect, []);
};

export default useMount;